import { memo, useMemo } from 'react';
import { type SharedImgixAndSourceProps } from 'react-imgix';

import { ImgixImage, type ImgixImageProps } from '@air/component-imgix-image';

import { getCloudFrontUrlFromImgixUrl } from '~/constants/cloudfront';

const ASSET_VERSION_THUMBNAIL_IMAGE_PREVIEW_IMGIX_PARAMS: SharedImgixAndSourceProps['imgixParams'] = {
  fit: 'clip',
  cs: 'origin',
};

export type AssetVersionThumbnailImagePreviewProps = Pick<ImgixImageProps, 'src'>;

export const AssetVersionThumbnailImagePreview = memo(({ src }: AssetVersionThumbnailImagePreviewProps) => {
  const fallbackUrl = useMemo(() => {
    if (src) {
      return getCloudFrontUrlFromImgixUrl(src);
    }

    return '';
  }, [src]);

  return (
    <div className="flex size-full items-center justify-center">
      <ImgixImage
        className="pointer-events-none block size-full object-cover"
        alt=""
        src={src}
        fallbackUrl={fallbackUrl}
        imgixParams={ASSET_VERSION_THUMBNAIL_IMAGE_PREVIEW_IMGIX_PARAMS}
        width={144}
      />
    </div>
  );
});

AssetVersionThumbnailImagePreview.displayName = 'AssetVersionThumbnailImagePreview';
